import { StepConnector, StepIconProps } from '@material-ui/core';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { CalendarScheduledIcon, WorkspaceIcon, BuildingIcon } from '../../../../assets/icons';

export const CustomStep = ({ active, completed, icon }: StepIconProps) => {
  const classes = useStepStyles();

  const icons: { [index: string]: React.ReactElement } = {
    1: <img src={CalendarScheduledIcon} alt="CalendarScheduledIcon" draggable="false" />,
    2: <img src={WorkspaceIcon} alt="WorkspaceIcon" draggable="false" />,
    3: <img src={BuildingIcon} alt="BuildingIcon" draggable="false" />,
    4: <img src={CalendarScheduledIcon} alt="CalendarScheduledIcon" draggable="false" />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(icon)]}
    </div>
  );
}

export default CustomStep;

const useStepStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      width: 110,
      height: 110,
      color: '#fff',

      backgroundColor: '#FFF',
      border: '3px solid #E0E0E0',
      borderRadius: '50%',

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      zIndex: 5,

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 70,
        maxHeight: 50,
        opacity: .2,
        filter: "drop-shadow(1px 1px 1px #00000029)",
        zIndex: 5,
      },
    },
    active: {
      background: '#FFF',
      border: `10px solid ${theme.palette.primary.light}`,
      borderRadius: '50%',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',

      '&:before': {
        content: "''",
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        border: `3px solid ${theme.palette.primary.main}`,
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: -1,
      },

      '& img': {
        opacity: 1,
      },
    },
    completed: {
      border: `10px solid ${theme.palette.primary.light}`,
      borderRadius: '50%',

      '&:before': {
        content: "''",
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        border: `3px solid ${theme.palette.primary.main}`,
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: -1,
      },

      '& img': {
        opacity: 1,
      },
    },
  })
);

export const StyledConnector = withStyles(({ palette }) => ({
  alternativeLabel: {
    top: 50,
  },
  active: {
    '& $line': {
      background: palette.primary.light
    },
  },
  completed: {
    '& $line': {
      background: palette.primary.light
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
}), { withTheme: true })(StepConnector);